import React from 'react';
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select
} from 'material-ui';

export const MaterialUISelect = (props) => {
    return (
        <FormControl style={{width: '100%'}}>
            <InputLabel htmlFor={'field-dd-' + props.id}>
                {props.label}
            </InputLabel>
            <Select
                value={props.selectedItem}
                onChange={event => {props.onChange(event)}}
                inputProps={{id: 'field-dd-' + props.id}}
                name={props.name}
            >
                {props.items.map((item, index) => {
                    return <MenuItem key={index} value={item.id} className={props.className}>{item.display_name}</MenuItem>
                })}
            </Select>
        </FormControl>
    )
}


// WEBPACK FOOTER //
// ./src/components/fields/field_material_ui_select.js